import { memo } from 'react';
import { handleFreeReturn } from '@lambda/commons/helpers';
import PaymentIcons from '@/components/collections/[handle]/NewProductPage/PaymentIcons';
import settings from '@/settings';
import i18n from '@/settings/i18n';

const t = i18n.init('shared');

const EntityBadge = ({ label }: { label: string }) => (
  <span className="rounded bg-gray-700/5 px-2 py-1 text-[11px] leading-none text-gray-700">
    {label}
  </span>
);

const Copyright = memo(() => {
  const country = t(settings.country);
  const entityText = t`© Reebelo ${{ country }} | ${{
    companyNo: settings.company_no,
  }}`;
  const taxText = settings.tax_registration
    ? [t(settings.tax_registration), settings.vat_number]
        .filter(Boolean)
        .join(' ')
    : undefined;
  const copyrightText = taxText ? `${entityText} | ${taxText}` : entityText;

  const freeReturnDays = handleFreeReturn(
    settings.store,
    settings.free_return_days,
  );

  return (
    <div className="bg-white py-4">
      <div className="reebelo-container flex flex-col-reverse justify-between lg:flex-row lg:gap-10">
        <div className="mt-4 flex flex-col flex-wrap items-start justify-start text-gray-700 sm:mb-0 lg:mt-0 lg:justify-end">
          <p className="w-full text-center text-xs sm:text-sm lg:text-left">
            {copyrightText}
          </p>
          <div className="mt-2 flex w-full flex-wrap justify-center gap-2 lg:justify-start">
            <EntityBadge label={t`Free Shipping to ${{ country }}`} />
            <EntityBadge
              label={t`${{
                days: String(freeReturnDays),
              }}-Day Returns in ${{ country }}`}
            />
          </div>
          {settings.country_code === 'SG' && (
            <p className="w-full text-center text-[10px] !leading-tight sm:text-[12px] lg:text-left">
              {t`QUISTA TECHNOLOGY PTE. LTD. is not regulated and does not purport to be regulated or to hold any form of licence issued by the Monetary Authority of Singapore.`}
            </p>
          )}
        </div>
        <div className="flex min-w-[200px] flex-col items-center">
          <div className="mb-2 text-xs text-gray-700">{t`100% Secure Payments`}</div>
          <div className="flex justify-center gap-2 xxs:gap-3">
            <PaymentIcons hideTitle />
          </div>
        </div>
      </div>
    </div>
  );
});

export default Copyright;
